import {
  ReferenceInput,
  SelectInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required,
  BooleanInput
} from 'react-admin';
import { UploadImageInput } from '../../components';
import UploadInput from '../../components/UploadInput';

export default function BrandsForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        autoComplete="off"
        fullWidth
        label="Nome"
        source="name"
        validate={[required()]}
      />

      <TextInput
        autoComplete="off"
        fullWidth
        label="Título"
        source="title"
        validate={[required()]}
      />

      <ReferenceInput
        fullWidth
        label="Categoria"
        sort={{ field: 'name', order: 'ASC' }}
        source="category"
        reference="brands-categories"
        validate={[required()]}
      >
        <SelectInput />
      </ReferenceInput>

      <TextInput
        autoComplete="off"
        fullWidth
        label="Descrição / Argumento de Venda"
        source="description"
        validate={[required()]}
      />

      <UploadImageInput
        fullWidth
        helperText="É possível enviar imagens no formato PNG com dimensões recomendadas de 168x288px."
        label="Imagem"
        upploadOptions={{
          maxSize: [168, 288]
        }}
        mimeTypes={['image/png', 'image/jpeg']}
        source="image"
        validate={[required()]}
      />

      <UploadInput
        fullWidth
        helperText="É possível enviar imagens nos formatos PNG e SVG."
        label="Marca"
        mimeTypes={['.png', '.svg']}
        source="logo"
        validate={[required()]}
      />
      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
